// The UFORouteName object is a global singleton
var UFORouteName = {
  current: null
};
export default UFORouteName;